import { Fragment } from "react";
import { Box } from "@mui/material";

const STEPS = [
  {
    number: "1",
    title: "Browse the library",
    body: "Explore simulations by subject, grade level, or learning goal.",
  },
  {
    number: "2",
    title: "Add your cohorts",
    body: "Group your participants so you can track progress by class or program.",
  },
  {
    number: "3",
    title: "Run your first simulation",
    body: "Launch a simulation with your cohort and watch your dashboard populate.",
  },
];

const GettingStartedSteps = () => (
  <Box
    className="edsimsV2-getting-started"
    role="list"
    aria-label="Getting started"
  >
    {STEPS.map((step, index) => (
      <Fragment key={step.number}>
        {index > 0 ? (
          <Box
            className="edsimsV2-getting-started-divider"
            aria-hidden="true"
          />
        ) : null}
        <Box className="edsimsV2-getting-started-step" role="listitem">
          <Box className="edsimsV2-getting-started-heading">
            <span className="edsimsV2-getting-started-badge" aria-hidden="true">
              {step.number}
            </span>
            <p className="edsimsV2-getting-started-title">{step.title}</p>
          </Box>
          <p className="edsimsV2-getting-started-body">{step.body}</p>
        </Box>
      </Fragment>
    ))}
  </Box>
);

export default GettingStartedSteps;
